import React, {
    Component
  }                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
  }                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import styles                 from './style'
import moment from 'moment';
import {Link}                 from 'react-router-dom';
import device           from "current-device";
import WebcamCapture from '../../../../components/reactCamera/reactCamera.js';
import CheckoutSummary from '../../CheckoutSummary';
import ToggleSwitch from '../../../../components/toggleSwitch/ToggleSwitch';


const is_mobile = device.mobile();

var count_of_drop_down = 2;
var count_of_section = 0;
function deepcopy(o) {
   var output, v, key;
   output = Array.isArray(o) ? [] : {};
   for (key in o) {
       v = o[key];
       output[key] = (typeof v === "object" && v instanceof File == false) ? deepcopy(v) : v;
   }
   return output;
}


class Checkout extends Component{
    static PropTypes = {
        actions: PropTypes.shape({
            enterPage: PropTypes.func,
            leavePage: PropTypes.func,
        })
    };

    constructor(props){
        super(props);
        this.state = {
            venues: [],
            openCamera:false,
            current_image_src:'',
            current_image_id:'',
            image_list:[],
            check_list: {"items":[]},
            response_list: [],
            check_list_type_zero:[],
            check_list_type_one:[{
                name:is_mobile?"....select....":"...... select ...... ",
            }],
            venue:'',
            text: 0,
            check_list_item_one:'',
            add_item:{
                  
            },
            responses:[],
            selected_item:[
                {
                  
                  id:'',
               
                  index: 0,
                  value: null,
                
              }
            ],

            collection_details:{
              '2000':0,
              '500':0,
              '200':0,
              '100':0,
              '50':0,
              '20':0,
              '10':0,
              '5':0,
              '2':0,
              '1':0,
            },
            total_collection:0,
            court_deatils:{},
            bulk_details:{},
            package_details:{},
            totals:{},
            success:false,
            collection:{
                cashbox_amount:0,
                cardmachine_amount:0,
                phonepe_amount:0
            },
            summary:false,
            checkout:true
          }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.postResponse = this.postResponse.bind(this);
        this.handleChecklist = this.handleChecklist.bind(this);
        this.handletask = this.handletask.bind(this);
        this.receivePicture = this.receivePicture.bind(this);
        this.b64toBlob = this.b64toBlob.bind(this);
        this.handleCount = this.handleCount.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
    }
    

    componentDidMount() {
        this.getChecklist();
        console.log(this.state);
        
    }



    getChecklist() {
      const url = `${getLocationOrigin()}/cm/get_desk_manager_checkout_list/`;
      const options = {...defaultOptions};
 
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          this.setState({venues: data.venues,check_list: data.check_list,venue:data.venues[0].id},()=>{this.getSummary()});
          this.handleChecklist();
          this.handletask();
         })
        .catch(error => error);
    }

    getSummary() {
      const url = `${getLocationOrigin()}/cm/get_checkout_summary/?venue=${this.state.venue}`;
      const options = {...defaultOptions};
 
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          this.setState({success:true,court_deatils:data.court_detail,bulk_details:data.bulk_detail,package_details:data.package_detail,
            totals:data.totals})
        })
        .catch(error => error);
    }

    handleSelection(event) {
      var name = event.target.name;
      if(name == 'summary'){
        this.setState({summary:true,checkout:false})
      }
      else if(name == 'checkout'){
        this.setState({checkout:true,summary:false})
      }
    }


    handletextcount(count,item,index){

            var old_obj = this.state.response_list;
            var selected_item_variable = this.state.selected_item;
            var index_count,a = 0;
            for ( var i = 0; i <= old_obj.length; i++){    
                if(old_obj[i]) {
                    var temp = old_obj[i];
                    if(temp.items==item){
                        a++;
                        index_count = i;
                    }  
                }  
            }
            var new_value =  {};
            new_value.items = item;
            new_value.response = count.target.value;
            
            selected_item_variable[index].value = count.target.value;
            this.setState({selected_item:selected_item_variable})
            if(a == 0)  { this.state.response_list.push(new_value);  
            }
            else{
                var temp = old_obj[index_count];
                old_obj.splice(index_count,1);
                old_obj.push(new_value);
                console.log(old_obj)
                this.setState({response_list:old_obj});
            }
    }

    b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
      
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }    



    addSection(event){
       console.log(this.state.selected_item[0].value)
      var last_elem = this.state.selected_item[this.state.selected_item.length -1]
      console.log(last_elem);
      if (last_elem.sessionSectionTitle != ""){
          var sections = deepcopy(this.state.selected_item);
          var add_new = {};
          add_new.index = count_of_section + 1;
          count_of_section = count_of_section +1;
          add_new.value = null;

          sections.push(add_new);
          if(count_of_drop_down < this.state.check_list_type_one.length){
                        this.setState({
                          selected_item: sections
                      });
                      count_of_drop_down ++ ;
                      
                      console.log("added section");
                      console.log(sections);
            }
      }
    }


    handletask(){
        var new_checklist = this.state.check_list.items;
        for(var i = 0; i <= new_checklist.length ; i++){
            var temp_obj = {};
             temp_obj = new_checklist[i];
            if (temp_obj.task_type == 1)
            {   
                this.state.check_list_type_one.push(temp_obj);
                console.log(this.state.check_list_type_one)
            }
            else if(temp_obj.task_type == 0){
                this.state.check_list_type_zero.push(temp_obj);
                console.log(this.state.check_list_type_zero)
            }

        }

    }

    handleToggle(name,checked) {
      console.log('checked',checked)
      console.log('name',name)

    }



    postResponse(event) {
        event.preventDefault();
        var null_count = 0
        var final_response = Object.assign([],this.state.response_list)
        for (var i = 0;i<final_response.length;i++){
            if(final_response[i].response == 'null'){
                null_count ++;
            }
        }
        if(null_count == 0){
          const url = `${getLocationOrigin()}/cm/save_tasks_for_checklist/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          var formData = new FormData();
          formData.append('response_list', JSON.stringify(this.state.response_list))
          formData.append('venue', this.state.venue)
          formData.append('total_cash',this.state.total_collection)
          formData.append('cash_details',JSON.stringify(this.state.collection_details))
          formData.append('collection_details',JSON.stringify(this.state.collection))
          formData.append('court_booking',JSON.stringify(this.state.court_deatils))
          formData.append('bulk_booking',JSON.stringify(this.state.bulk_details))
          formData.append('memberships',JSON.stringify(this.state.package_details))
          formData.append('check_type', "Checkout")
          formData.append('short_code', "desk_manager_check_out")
          var image_ids = []
          for (var i = this.state.image_list.length - 1; i >= 0; i--) {
            var img = this.state.image_list[i]
            formData.append("image_" + img['id'],this.b64toBlob(img['picture'],'image/jpeg' ))                                                                        
            image_ids.push(img['id'])
          };
          formData.append('image_ids',JSON.stringify(image_ids))                                  
          
          options['body'] = formData

          return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                      // first then()
                alert("Successfully checked out with details tasks")
                this.props.history.goBack();
                location.reload();

                     })
            .catch(error => {
              console.log(error);
              alert(error.message);
            });
          }
          else{
            alert('Please check all tasks')
          }


    }
    


    handleChange(event,index) {
        const name = event.target;
        var temp_item ={};
        var old_value = 0;
        var temp_list = this.state.response_list;
        var selected_item_variable = this.state.selected_item;
        if(name.name=='venue'){
            this.setState({venue:name.value},()=>{this.getSummary()});
        }
        else if (name.name == 'items'){
            temp_item.id = event.target.value;
            temp_item.index = index
            if(this.state.add_item.index == index){
                for ( var i = 0; i < temp_list.length; i++){    
                    if(temp_list[i]){
                    var temp = temp_list[i];
                    if(temp.items==this.state.add_item.id)
                    {   
                        old_value = temp_list[i].response;
                        temp_list[i].response = 'null';
                        this.setState({response_list:temp_list});
                    }  
                    
                }}
            }

            for ( var i =0;i<this.state.selected_item.length;i++){
                
                if(index == selected_item_variable[i].index){
                    selected_item_variable[i].id = event.target.value;

                    this.setState({selected_item:selected_item_variable})
                }
            }
            for ( var i = 0; i < temp_list.length; i++){    
                    if(temp_list[i]){
                    var temp = temp_list[i];
                    if(temp.items == event.target.value){
                                temp_list[i].response = old_value;

                                this.setState({response_list:temp_list});

                            }
            }}
            temp_item.value = old_value;
            this.setState({add_item:temp_item});
        }
        else{
          var new_collection = Object.assign({},this.state.collection)
          new_collection[name.name] = name.value
          this.setState({collection:new_collection})

        }

    }

    handleChecklist(){
        var checklist_items = this.state.check_list
        var new_value =  {};
        var old_obj = this.state.check_list.items;



        for (var i=0;i<old_obj.length;i++){
            if(old_obj[i].task_type == 0){
                new_value =  {};
                new_value.items = old_obj[i].id;
                new_value.response = "null";
                console.log(new_value)
                this.state.response_list.push(new_value);
            }
            // else if(old_obj[i].task_type == 1){
            //     new_value =  {};
            //     new_value.items = old_obj[i].id;
            //     new_value.response = 0;
            //     console.log(new_value)
            //     this.state.response_list.push(new_value);
            // }
        }

        
        
    }
    
    handleRadio = (e, s) => {
        var old_obj = this.state.response_list;
        var index,count = 0;
        for ( var i = 0; i <= old_obj.length; i++){    
            if(old_obj[i]) {
                var temp = old_obj[i];
                if(temp.items==s){
                    count ++;
                    index = i;
                }  
            }  
        }
            var new_value =  {};
            new_value.items = s;
            new_value.response = e.target.value;
                     
            if(count == 0)  { this.state.response_list.push(new_value);  
              console.log(old_obj)}
            else{
                var temp = old_obj[index];
                old_obj.splice(index,1);
                old_obj.push(new_value);
                console.log(old_obj)
                this.setState({response_list:old_obj});
            }
    }
    receivePicture(imageSrc){
      console.log(imageSrc)
      var image_adding_count = 0 ;
      var task_respose = Object.assign([], this.state.image_list);
      for(var t= 0;t<task_respose.length;t++){
        if(task_respose[t].id == this.state.current_image_id){
          task_respose[t].picture = imageSrc;
          image_adding_count ++;
        }
      }
      if(image_adding_count==0){
        this.state.image_list.push({'id':this.state.current_image_id,'picture':imageSrc})
      }else{
        this.setState({image_list:task_respose,})        
      }
      this.setState({current_image_src:imageSrc,openCamera:false}) 
      console.log(this.state)
    }

    openCamera(task_id){
      if(task_id == this.state.current_image_id){
        this.setState({openCamera:!this.state.openCamera});
      }
      else {
      this.setState({openCamera:true,current_image_id:task_id});
      }
    }

    handleSubmit(event){
        event.preventDefault();
        this.postResponse(event);
        console.log('post');
        console.log(this.state.response_list);
    }

    handleCount(event){
      var name = event.target.name;
      var value = event.target.value;
      var details = Object.assign({}, this.state.collection_details);
      details[name] = value;
      this.setState({collection_details:details},()=>{this.updateTotal()})
    }

    updateTotal(){
      var total = 0;
      Object.keys(this.state.collection_details).map((each)=>
        total += parseInt(each)*this.state.collection_details[each]
        )
      this.setState({total_collection:total})
    }


    render(){
        console.log(this.state)
        var rupee_array = ['2000','500','200','100','50','20','10','5','2','1']
        return(
        <div style={styles.container} style={styles.container}>
            <div className="row col-md-12 table-bordered" style={styles.table}>
                <div style={styles.main_header} >
                    Check Out
                </div>

                <div className="col-md-12" style={{display:'flex',flexDirection:'row'}} >
                    <div style={styles.item_header}  className="col-md-3">
                        Venue
                    </div>
                    
                    
                    <div className="col-md-6">
                        <select name="venue" value={this.state.venue}
                            onChange={this.handleChange}>
                            {
                            this.state.venues.map((venue, index) => (
                            <option key={venue.id} value={venue.id}>{venue.name}</option>
                            ))
                            }
                        </select>
                    </div>
                </div> 

                <div className="col-md-12" style={{display:'flex',flexDirection:'row',justifyContent:'space-evenly',marginTop:'2%'}}>
                  <button className='button1' style={this.state.summary?{marginRight:'1%',opacity:'0.6'}:{marginRight:'1%'}} name='summary' onClick={this.handleSelection}> Today's Summary </button>
                  <button className='button1' style={this.state.checkout?{marginRight:'1%',opacity:'0.6'}:{marginRight:'1%'}} name='checkout' onClick={this.handleSelection}> Checkout Session </button>
                </div>

                { this.state.summary &&
                  <CheckoutSummary venue={this.state.venue}/>
                }

                { this.state.checkout &&
                  <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
                          <div style={styles.items} className="col-md-12">
                                       
                             <div className="col-md-12" style={{color:'red',textAlign:'left',marginLeft:'10%',paddingTop:'1%'}} > * Please fill out all the fields with relevant images.<br/> * Select NA if facility is not available.</div>                                
                              <div style={styles.check_list}  className="col-md-12">
                                  {
                                  this.state.check_list.items.map((check_list_item, index) => (check_list_item.task_type == 0 &&
                                      <div >
                                          
                                          <div style={{display:'flex',flexDirection:'row'}} >
                                              <div className="col-md-6" style={styles.check_list_task} >
                                                  <div key={index.id} value={index}>{check_list_item.name}</div>     
                                              </div>
                                              
                                              <div className="col-md-6" style={{display:'flex',flexDirection:'row'}}>
                                                  
                                                  <div style={styles.radio_button} >
                                                  <input type="radio" 
                                                       value="YES" name= {check_list_item.name}
                                                      onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                    />
                                                  YES
                                                 </div>
                                                 <div style={styles.radio_button}>
                                                  <input type="radio" 
                                                       value="NO" name= {check_list_item.name}
                                                      onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                    />
                                                  NO
                                                 </div>
                                                 <div style={styles.radio_button}>
                                                  <input type="radio" 
                                                       value="NA" name= {check_list_item.name}
                                                      onChange={(e) => this.handleRadio(e,check_list_item.id)}
                                                    />
                                                  NA
                                                 </div>
                                                 <i className="far fa fa-camera" style={{fontSize:'150%',marginLeft:'5%',marginTop:'1%'}} onClick={(e)=>this.openCamera(check_list_item.id)} > </i>
                                              </div>
                                            </div>

                                            {this.state.image_list.map((image,index)=>(
                                                  <div className="image_container" style={{textAlign:'center',margin:5}} >{image.id == check_list_item.id &&
                                                        <img id={image.id} style={{marginTop:'1%'}} src={image.picture} alt="Image 1" /> 
                                                      }
                                                  </div>))
                                            }
                                            {this.state.openCamera && check_list_item.id == this.state.current_image_id &&
                                            <div style={{textAlign:'center'}}>
                                                <WebcamCapture  callback={this.receivePicture}/>
                                            </div>
                                            }
                                      </div>
                                  ))
                                  }                            
                                </div>
                              </div>
                              { this.state.success &&
                                <div style={{backgroundColor:'white',marginTop:'2%'}}  className="col-md-12">
                                  <div className="heading heading2 left" style={styles.header}>Summary of Today's Collection </div> 
                                  <table className="table">
                                    <tr>
                                      <th style={{textAlign:'center'}}> Type </th>
                                      <th style={{textAlign:'center'}}> Website/App </th>
                                      <th style={{textAlign:'center'}}> Cash </th>
                                      <th style={{textAlign:'center'}}> Card Machine </th>
                                      <th style={{textAlign:'center'}}> Phone Pe </th>
                                      <th style={{textAlign:'center'}}> Bank </th>
                                      <th style={{textAlign:'center'}}> Others </th>
                                      <th style={{textAlign:'center'}}> Total </th>
                                      <th style={{textAlign:'center'}}> Approval </th>
                                    </tr>

                                    <tr>
                                      <td style={{textAlign:'center'}}> {this.state.court_deatils['type']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.court_deatils['web_app']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.court_deatils['cash']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.court_deatils['card_machine']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.court_deatils['phonepe']} </td>
                                      <th style={{textAlign:'center'}}> {this.state.court_deatils['bank']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.court_deatils['others']} </th>
                                      <td style={{textAlign:'center'}}> {this.state.court_deatils['total']} </td>
                                      <td style={{textAlign:'center'}}>
                                        <ToggleSwitch
                                          id="court_deatils"
                                          name="court_deatils"
                                          small
                                          checked={this.state.court_deatils['is_approved']}
                                          onChange={()=>{
                                            let new_state = Object.assign({}, this.state.court_deatils);
                                            new_state['is_approved'] = !this.state.court_deatils['is_approved']
                                            this.setState({court_deatils:new_state})}
                                          }
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td style={{textAlign:'center'}}> {this.state.bulk_details['type']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.bulk_details['web_app']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.bulk_details['cash']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.bulk_details['card_machine']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.bulk_details['phonepe']} </td>
                                      <th style={{textAlign:'center'}}> {this.state.bulk_details['bank']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.bulk_details['others']} </th>
                                      <td style={{textAlign:'center'}}> {this.state.bulk_details['total']} </td>
                                      <td style={{textAlign:'center'}}>
                                        <ToggleSwitch
                                          id="bulk_details"
                                          name="bulk_details"
                                          small
                                          checked={this.state.bulk_details['is_approved']}
                                          onChange={()=>{
                                            let new_state = Object.assign({}, this.state.bulk_details);
                                            new_state['is_approved'] = !this.state.bulk_details['is_approved']
                                            this.setState({bulk_details:new_state})}
                                          }
                                        />
                                      </td>
                                    </tr>

                                    <tr>
                                      <td style={{textAlign:'center'}}> {this.state.package_details['type']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.package_details['web_app']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.package_details['cash']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.package_details['card_machine']} </td>
                                      <td style={{textAlign:'center'}}> {this.state.package_details['phonepe']} </td>
                                      <th style={{textAlign:'center'}}> {this.state.package_details['bank']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.package_details['others']} </th>
                                      <td style={{textAlign:'center'}}> {this.state.package_details['total']} </td>
                                      <td style={{textAlign:'center'}}>
                                        <ToggleSwitch
                                          id="package_details"
                                          name="package_details"
                                          small
                                          checked={this.state.package_details['is_approved']}
                                          onChange={()=>{
                                            let new_state = Object.assign({}, this.state.package_details);
                                            new_state['is_approved'] = !this.state.package_details['is_approved']
                                            this.setState({package_details:new_state})}
                                          }
                                        />
                                      </td>
                                    </tr>
     
                                    <tr>
                                      <th style={{textAlign:'center'}}> {this.state.totals['type']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.totals['web_app']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.totals['cash']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.totals['card_machine']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.totals['phonepe']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.totals['bank']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.totals['others']} </th>
                                      <th style={{textAlign:'center'}}> {this.state.totals['total']} </th>
                                    </tr>
                                  </table>                            
                                </div>
                              }

                              <div style={{backgroundColor:'white',marginTop:'2%'}}  className="col-md-12">
                                <div className="heading heading2 left" style={styles.header}>Checkout Screen</div>
                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Cashbox
                                  </div>
                                  <input type='number' className={styles.input} onChange={this.handleChange} name='cashbox_amount' placeholder='enter cashbox amount' value={this.state.value} />
                                </div>
                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Card Machine
                                  </div>
                                  <input type='number' className={styles.input} onChange={this.handleChange} name='cardmachine_amount' placeholder='enter card machine amount' value={this.state.value} />
                                </div>
                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Phonepe
                                  </div>
                                  <input type='number' className={styles.input} onChange={this.handleChange} name='phonepe_amount' placeholder='enter phonepe amount' value={this.state.value} />
                                </div>
                                <div style={{color:'red'}}>
                                If the amount entered in the checkout screen is not matching with the summary table, the finance team will ask for clarification the next day.
                                </div>
                                
                              </div>
                                

                              <div style={{backgroundColor:'white',marginTop:'2%'}}  className="col-md-12">
                                <div className="heading heading2 left" style={styles.header}>Cash In Desk</div> 
                                <table className="table">
                                  <tr>
                                    <th style={{textAlign:'center'}}> Amount </th>
                                    <th style={{textAlign:'center'}}> Count </th>
                                  </tr>

                                  { rupee_array.map(each=>(
                                      <tr>
                                        <td style={{textAlign:'center'}}>{each}</td>
                                        <td style={{textAlign:'center'}}> <input type='number' name={each} onChange={this.handleCount} value={this.state.value} placeholder={0}/> </td>
                                      </tr>
                                    ))
                                  }
                                  <tr>
                                    <th style={{textAlign:'center'}}> Total Amount </th>
                                    <th style={{textAlign:'center'}}> {this.state.total_collection} </th>
                                  </tr>
                                </table>                            
                              </div>
                      
                          <div style={styles.button_submit} className="col-md-12">
                              <input className="button1" type="submit" value="Check Out" />
                          </div>
                  
                  </form>
                }
            </div>
        </div>    
        );
    }
}

export default Checkout;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/checkout/index.js